/**
 * What a local dev server tells its page about where it runs from, so several local apps or
 * Storybooks open side by side can be told apart. One definition for every side of it: the vite
 * plugin (`vite-plugins/devOrigin.ts`), Storybook's server preset and toolbar
 * (`.storybook/local-preset.ts`) and the app (`DevOriginService`) — keep it free of imports, it
 * is loaded by all of them.
 */
export interface DevOrigin {
  /** Absolute path of the checkout the server runs from — a worktree's own folder for a worktree. */
  directory: string;
  /** Checked-out branch; a short sha on a detached HEAD, `null` outside a git checkout. */
  branch: string | null;
}

export const devOriginEvents = {
  /** Page → server: send me the current origin. */
  request: 'satie:dev-origin:request',
  /** Server → page: the origin, answered on request and pushed whenever HEAD moves. */
  update: 'satie:dev-origin:update'
} as const;
